import React from 'react'
import PropTypes from 'prop-types'

/** icon dấu cộng tại màn hình food_detail */
const AddIcon = ({ size = '15', color = 'white' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.69699 0.212158V6.27319V6.27326H8.69741H14.7584V8.69751H8.69741H8.69699V14.7585H6.27275V8.69751H0.212128V6.27326H6.27275V6.27319V0.212158H8.69699Z"
        fill={color}
      />
    </svg>
  )
}

export default React.memo(AddIcon)
AddIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
}
